"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Model_1 = __importDefault(require("../Model"));
var math_1 = require("../../helpers/math");
var date_1 = require("../../helpers/date");
var array_1 = require("../../helpers/array");
var defaultStats = {
    current: 0,
    max: 0,
};
var ListModel = /** @class */ (function (_super) {
    __extends(ListModel, _super);
    function ListModel(list, getters) {
        var _this = _super.call(this, getters) || this;
        _this.id = list.id;
        _this.name = list.name;
        _this.slug = list.slug;
        _this.sessionId = list.sessionId;
        _this.userId = list.userByUserId || list.userId;
        _this.assertionRate = list.assertionRate;
        _this.createdAt = list.createdAt;
        _this.totalQuestions = list.totalQuestions;
        _this.timesCompleted = list.timesCompleted;
        _this.schoolId = list.schoolBySchoolId || list.schoolId;
        _this.applicationType = list.applicationType;
        _this.metadata = list.metadata;
        _this.stats = _this.getListStats();
        return _this;
    }
    ListModel.prototype.getListStats = function () {
        if (this.newProgress)
            return this.newProgress.stats;
        return this.listItems.reduce(function (acc, listItem) {
            var behavior = listItem.behavior || '';
            var done = !!(listItem && (listItem.isObjective() ? listItem.question.answered : listItem.isCompleted()));
            if (acc[behavior]) {
                acc[behavior] = {
                    current: acc[behavior].current + +done,
                    max: acc[behavior].max + 1,
                };
            }
            else {
                acc[behavior] = {
                    current: 0 + +done,
                    max: 1,
                };
            }
            return acc;
        }, {});
    };
    Object.defineProperty(ListModel.prototype, "listItems", {
        get: function () {
            return this.getters
                .listItemsByListId(this.id)
                .concat()
                .sort(array_1.positionAscending);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "questions", {
        get: function () {
            return this.listItems.filter(function (listItem) { return listItem.questionId; }).map(function (listItem) { return listItem.question; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "articles", {
        get: function () {
            return this.listItems.filter(function (listItem) { return listItem.articleId; }).map(function (listItem) { return listItem.article; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "videos", {
        get: function () {
            return this.listItems.filter(function (listItem) { return listItem.videoId; }).map(function (listItem) { return listItem.video; });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "timeSinceCreation", {
        get: function () {
            if (!this.createdAt)
                return null;
            return date_1.timeSinceCreation(this.createdAt);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "school", {
        get: function () {
            return this.getters.schoolById(this.schoolId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "textStats", {
        get: function () {
            return this.stats['article'] || defaultStats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "videoStats", {
        get: function () {
            return this.stats['video'] || defaultStats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "questionStats", {
        get: function () {
            return this.stats['question'] || defaultStats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "triviaStats", {
        get: function () {
            return this.stats['trivia'] || defaultStats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "practiceStats", {
        get: function () {
            return this.stats['practice'] || defaultStats;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "listStats", {
        get: function () {
            return {
                current: this.textStats.current +
                    this.videoStats.current +
                    this.questionStats.current +
                    this.triviaStats.current +
                    this.practiceStats.current,
                max: this.textStats.max +
                    this.videoStats.max +
                    this.questionStats.max +
                    this.triviaStats.max +
                    this.practiceStats.max,
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "progress", {
        get: function () {
            if (this.listStats.max === 0)
                return 0;
            else
                return math_1.progressFormat((this.listStats.current * 100) / this.listStats.max);
        },
        enumerable: true,
        configurable: true
    });
    ListModel.prototype.isCompleted = function () {
        return this.progress === 100;
    };
    Object.defineProperty(ListModel.prototype, "newProgress", {
        get: function () {
            if (!this.getters.listProgressById)
                return null;
            var listProgress = this.getters.listProgressById(this.id);
            if (!listProgress)
                return null;
            return listProgress;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListModel.prototype, "firstIncompleteListItem", {
        get: function () {
            var _a;
            return (_a = this.listItems) === null || _a === void 0 ? void 0 : _a.find(function (item) {
                return item.progress < 100;
            });
        },
        enumerable: true,
        configurable: true
    });
    return ListModel;
}(Model_1.default));
exports.ListModel = ListModel;
